// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3c-1";
export var movingGradient = "_3c-4";
export var movingGradientBlock = "_3c-2";
export var skeleton = "_3c-0";
export var skeletonText = "_3c-3";